import store from 'client/store/store';
import { getAccountOrGoToLoginPage } from 'client/utils/auth/msalHelpers';

const selectEpsgCodeFromStore = (state) => {
    return state.mapConfig.result?.mapView.projection.replace('EPSG:', '');
};

const getValueFromMapConfig = async (selector) => {
    // Loads a value from the map config
    // Assumes that AuthProvider has kicked off a request for the user's map config.
    // I'd like to kick that request off here instead, but I don't have access to user.mapConfiguration here.
    // A better way would be to put the user's map config id from their profile into the redux store.
    // we could do this in AuthProvider right after we get the profile, instead of kicking off the map config request.
    // Then this mapconfig helper can handle sending the map config request itself;
    // return the map config if we have it, wait for the request if it's pending, or send the request if it's not yet pending

    // If we don't wait for the user to be logged in
    // then when you hit this page while not logged in
    // we subscribe to the store and wait forever for the map config to populate it.
    // Waiting for msal login ensures that authprovider/loadUser has been called
    // And thus mapconfig load is happening
    await getAccountOrGoToLoginPage();

    const getValueOrError = () => {
        const state = store.getState();
        if (state.mapConfig?.error) {
            throw new Error('Error loading map config. Try refreshing the page.');
        }

        if (!state.mapConfig?.loading && state.mapConfig?.result) {
            // Map config has loaded, let's see if we have the droids we're looking for
            const value = selector(state);

            if (value) {
                return value;
            } else {
                // eslint-disable-next-line no-console
                console.error(state.mapConfig?.result);
                throw new Error('Map config has loaded but an expected value is missing. Try refreshing the page.');
            }
        }
    };
    const value = getValueOrError();
    if (value) {
        // This runs when we are logged in and have loaded the mapconfig,
        // and then the user does an SPA-style navigation
        // e.g. clicked a react-router navlink to load another page without losing state
        return value;
    }

    // Otherwise wait for the map config value and resolve when it's here.
    // This runs if the user has loaded the app 'cold'
    // e.g. loaded /enquiries/ directly without hitting another page in the app first
    // or if the page hot-reloads during development.
    return new Promise((resolve, reject) => {
        const unsubscribe = store.subscribe(() => {
            try {
                const value = getValueOrError();
                if (value) {
                    resolve(value);
                    unsubscribe();
                }
            } catch (e) {
                reject(e);
                unsubscribe();
            }
        });
    });
};

const getEpsgCode = async () => getValueFromMapConfig(selectEpsgCodeFromStore);
const getBaseMapProperties = async () => getValueFromMapConfig(state => state.mapConfig.result.baseMaps[0]);

export {
    getEpsgCode,
    getBaseMapProperties,
    getValueFromMapConfig
};
